(function () {
  function initWhatsAppContact() {
    if (document.getElementById('wa-contact-widget')) return;

    const phoneNumber = '923399287924';

    const widget = document.createElement('div');
    widget.id = 'wa-contact-widget';

    widget.innerHTML = `
      <style>
        #wa-contact-widget,
        #wa-contact-widget * {
          box-sizing: border-box;
        }

        #wa-contact-widget .wa-launcher {
          position: fixed;
          right: 22px;
          bottom: 60px;
          z-index: 2147483646;
          width: 50px;
          height: 50px;
          padding: 0;
          border: none !important;
          border-radius: 50%;
          background: #25D366;
          color: #fff;
          cursor: pointer;
          box-shadow: 0 4px 14px rgba(0, 0, 0, .18);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform .2s ease, box-shadow .2s ease;
        }

        #wa-contact-widget .wa-launcher:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 18px rgba(0, 0, 0, .22);
        }

        #wa-contact-widget .wa-launcher svg {
          display: block;
          width: 29px;
          height: 29px;
          fill: currentColor;
        }

        #wa-contact-widget .wa-launcher:focus-visible {
          outline: 2px solid #128c45 !important;
          outline-offset: 3px;
        }

        @media (max-width: 480px) {
          #wa-contact-widget .wa-launcher {
            right: 15px;
            bottom: 60px;
            width: 48px;
            height: 48px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          #wa-contact-widget *,
          #wa-contact-widget *::before,
          #wa-contact-widget *::after {
            animation: none !important;
            transition: none !important;
          }
        }
      </style>

      <button type="button" class="wa-launcher"
        aria-label="Chat with us on WhatsApp">
        <svg viewBox="0 0 32 32" aria-hidden="true">
          <path d="M16 .8A15.1 15.1 0 0 0 3.1 23.8L1 31l7.4-1.9A15.2 15.2 0 1 0 16 .8Zm0 27.5a12.3 12.3 0 0 1-6.3-1.7l-.5-.3-4.4 1.2 1.2-4.3-.3-.5A12.3 12.3 0 1 1 16 28.3Zm6.8-9.2c-.4-.2-2.2-1.1-2.6-1.2-.4-.1-.6-.2-.9.2-.3.4-1 1.2-1.2 1.4-.2.3-.5.3-.9.1-.4-.2-1.6-.6-3.1-1.9-1.1-1-1.9-2.2-2.1-2.6-.2-.4 0-.6.2-.8l.6-.7c.2-.2.3-.4.4-.6.1-.3 0-.5 0-.7-.1-.2-.9-2.1-1.2-2.8-.3-.7-.6-.6-.9-.6h-.8c-.3 0-.7.1-1.1.5-.4.4-1.4 1.3-1.4 3.2s1.4 3.7 1.6 4c.2.3 2.8 4.3 6.8 6 .9.4 1.6.6 2.1.7.9.3 1.7.2 2.3.1.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.8-.1-.2-.4-.3-.8-.5Z"/>
        </svg>
      </button>
    `;

    
    document.body.appendChild(widget);

    const launcher = widget.querySelector('.wa-launcher');

    const message =
      "Assalamu Alaykum!\n\nI’m contacting you from the Shopify website and would like to know more.";

    launcher.addEventListener('click', function () {
      const url = 'https://wa.me/' + phoneNumber +
        '?text=' + encodeURIComponent(message);

      window.open(url, '_blank');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatsAppContact);
  } else {
    initWhatsAppContact();
  }
})();
